import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextUnderlineIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="textUnderline" ref={ref} {...props}>
    <path d="M12,16.75a7,7,0,0,1-7.17-6.69V3.8a.75.75,0,1,1,1.5,0v6.26A5.46,5.46,0,0,0,12,15.25a5.46,5.46,0,0,0,5.67-5.19V3.8a.75.75,0,0,1,1.5,0v6.26A7,7,0,0,1,12,16.75ZM21.47,20a.76.76,0,0,0-.75-.75H3.28a.75.75,0,0,0,0,1.5H20.72A.76.76,0,0,0,21.47,20Z" />
  </Icon>
)) as IconWithRender;

TextUnderlineIcon.displayName = 'TextUnderlineIcon';
TextUnderlineIcon.renderIcon = (props) => <TextUnderlineIcon {...props} />;
export default TextUnderlineIcon;
